import { useMemo } from "react";
import { useEntities, Compare, distinct, useJoinedEntities } from "@emberly/zenith-client";
import { JOIN_ORDER_AND_MISSION } from "../common/queries";

export function useOrdersWithMissions(query) {

  const { entities: orders, loading: ordersLoading } = useJoinedEntities("Order", query, JOIN_ORDER_AND_MISSION);
  const missionIds = useMemo(() => distinct(orders, t => t.missionId), [orders]);

  const { entities: relatedOrders, loading: relatedOrdersLoading } = useEntities("Order", useMemo(() => ({
    path: "missionId",
    comparer: Compare.IN,
    value: missionIds
  }), [missionIds]), missionIds.length !== 0);

  const showLoading = (ordersLoading && orders.length === 0) || relatedOrdersLoading && missionIds.length !== 0;

  const missions = useMemo(() => {
    const map = new Map();

    orders.forEach(order => {
      if (!map.has(order.missionId)) {
        map.set(order.missionId, order.mission);
      }
    });

    return [...map.values()];
  }, [orders]);

  return {
    orders,
    relatedOrders,
    showLoading,
    missionIds,
    missions
  };
}